import { useMutation } from '@tanstack/react-query'
import updateGlobalWhatsNew from '../api/whatsnew/updateGlobalWhatsNew'

const useUpdateGlobalWhatsNew = () => {
  return useMutation((updateGlobalWhatsNewObj: any) =>
    updateGlobalWhatsNew(updateGlobalWhatsNewObj),
  )
}

export default useUpdateGlobalWhatsNew
